import React, { PureComponent } from "react";
import {
  Button,
  Card,
  Col,
  Row,
  Form,
  Input,
  Select,
  Collapse
} from "antd/lib/index";
import { Field, FieldArray } from "formik";
import uuid from "uuid/v4";
import CustomTriviaArray from "../actividades/TriviaFieldArray";
import CustomCasillasArray from "../actividades/CustomCasillaArray";
import CustomUploadArray from "../actividades/CustomUploadArray";
import CustomLinkArray from "../actividades/CustomLinkArray";

const EtapaComponent = ({ field, ...props }) => {
  return <Input type="text" {...field} {...props} />;
};

const StatusComponent = ({ field, ...props }) => {
  return (
    <Form.Item label="Status">
      <Select
        defaultValue="wait"
        style={{ width: 120 }}
        onChange={value => props.form.setFieldValue(field.name, value)}
      >
        <Select.Option value="wait">En espera</Select.Option>
        <Select.Option value="process">En curso</Select.Option>
        <Select.Option value="finish">Terminado</Select.Option>
      </Select>
    </Form.Item>
  );
};

const TipoActividadComponent = ({ field, ...props }) => {
  return (
    <Form.Item label="Tipo de Actividad">
      <Select
        defaultValue={field.value || "empty"}
        style={{ width: 350 }}
        onChange={value => props.form.setFieldValue(field.name, value)}
      >
        <Select.Option value="transfer">
          Creación de grupos de alumnos
        </Select.Option>
        <Select.Option value="trivia">Crear trivia</Select.Option>
        <Select.Option value="casillas">Casillas</Select.Option>
        <Select.Option value="upload">Upload</Select.Option>
        <Select.Option value="imageSet">Set de Imagenes</Select.Option>
        <Select.Option value="link">Links</Select.Option>
        <Select.Option value="empty">Sin tipo de actividad</Select.Option>
      </Select>
    </Form.Item>
  );
};

const ActividadesComponent = ({ field, ...props }) => {
  return (
    <Form.Item label="Descripción">
      <Input.TextArea
        onPressEnter={() => {
          console.log("Enter in the right one");
        }}
        autosize={{ minRows: 2 }}
        type="text"
        {...field}
        {...props}
      />
    </Form.Item>
  );
};

const NumeroActividadComponent = ({ field, ...props }) => {
  return (
    <Form.Item label="Numero de actividad">
      <Input
        type="number"
        {...field}
        {...props}
      />
    </Form.Item>
  );
};


class EtapaForm extends PureComponent {
  render() {
    const { index, values } = this.props;
    return (
      <Collapse>
        <Collapse.Panel header={`Etapa ${index + 1}`}>
          <Card>
            <Form.Item label={`Titulo Etapa ${index + 1}`}>
              <Field
                name={`etapas.${index}.nombreEtapa`}
                component={EtapaComponent}
              />
            </Form.Item>
            <Field
              name={`etapas.${index}.status`}
              component={StatusComponent}
            />
            <FieldArray
              name={`etapas.${index}.actividades`}
              render={helpers => (
                <React.Fragment>
                  {values.etapas[index].actividades.map((actividad, i) => (
                    <Row key={i} type="flex" align="middle">
                      <Col span={22}>
                        <Form.Item label={`Titulo Actividad ${i + 1}`}>
                          <Field
                            name={`etapas.${index}.actividades.${i}.tituloActividad`}
                            component={EtapaComponent}
                          />
                        </Form.Item>

                        <Field
                          name={`etapas.${index}.actividades.${i}.descripcionActividad`}
                          component={ActividadesComponent}
                        />
                        <Field
                          name={`etapas.${index}.actividades.${i}.numeroActividad`}
                          component={NumeroActividadComponent}
                        />
                        <Field
                          name={`etapas.${index}.actividades.${i}.tipoActividad`}
                          component={TipoActividadComponent}
                        />
                        {values.etapas[index].actividades[i].tipoActividad ===
                          "link" && (
                            <CustomLinkArray
                              etapaIndex={index}
                              actividadIndex={i}
                              values={values}
                            />
                          )}
                        {values.etapas[index].actividades[i].tipoActividad ===
                          "trivia" && (
                            <CustomTriviaArray
                              etapaIndex={index}
                              actividadIndex={i}
                              values={values}
                            />
                          )}
                        {values.etapas[index].actividades[i].tipoActividad ===
                          "casillas" && (
                            <CustomCasillasArray
                              etapaIndex={index}
                              actividadIndex={i}
                              values={values}
                            />
                          )}
                        {values.etapas[index].actividades[i].tipoActividad ===
                          "upload" && (
                            <CustomUploadArray
                              etapaIndex={index}
                              actividadIndex={i}
                              values={values}
                            />
                          )}
                      </Col>
                      <Col span={2}>
                        <Button type="button" onClick={() => helpers.remove(i)}>
                          -
                        </Button>
                      </Col>
                    </Row>
                  ))}
                  <Button
                    type="button"
                    onClick={() => helpers.push({ key: uuid() })}
                  >
                    +
                  </Button>
                </React.Fragment>
              )}
            />
          </Card>
        </Collapse.Panel>
      </Collapse>
    );
  }
}

export default EtapaForm;
